/**
 * Route definitions for the crypto payins SPA.
 *
 * Routes:
 *   PAY     /pay/:sessionHash    → Pay flow
 *   SETUP   /setup/:sessionHash  → Setup flow
 *   RETURN  /refund/:sessionHash → Return details collection flow
 *   FUND    /fund/:sessionHash   → Funding session flow
 *   CATCH_ALL *                  → 404
 */

const routes = {
  PAY: '/pay/:sessionHash',
  SETUP: '/setup/:sessionHash',
  RETURN: '/refund/:sessionHash',
  FUND: '/fund/:sessionHash',
  CATCH_ALL: '*',
} as const;

export default routes;

type RouteParams = {
  PAY: {params: {sessionHash: string}};
  SETUP: {params: {sessionHash: string}};
  RETURN: {params: {sessionHash: string}};
  FUND: {params: {sessionHash: string}};
  CATCH_ALL: {params?: {glob?: string[]}};
};

declare global {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface SailNavigationRouteParams extends RouteParams {}
}
